import { deepClone } from '@/modules/objectUtils';
import layouts from '../dragAndMatchLayouts';
import { getAspectRatioRangeFromLayout } from '@/shared/GameComponents/libs/layout/getAspectRatioRange';

export function getDragAndMatchLayout(images, texts, aspectRatio, stageWidth) {
  const aspectRatioId = getAspectRatioRangeFromLayout(aspectRatio, layouts[15]);
  const imgs = deepClone(images);
  const { size, layout, textRegion, textColumns, fontSize } =
    layouts[imgs.length][aspectRatioId];
  console.log('==>>', aspectRatioId, size, fontSize);
  const pivot = { x: 50, y: 50 };
  const rows = layout.length;
  const columns = layout[0].length;

  const gap = [(100 - columns * size) / columns, (100 - rows * size) / rows];
  const positionedImages = [];
  let currentImgIndex = 0;
  for (let i = 0; i < layout.length; i++) {
    for (let j = 0; j < layout[i].length; j++) {
      if (layout[i][j]) {
        const currentImg = imgs[currentImgIndex];
        if (currentImg) {
          positionedImages.push({
            id: currentImg.id,
            atlasImg: currentImg.atlasImg,
            transform: {
              x: gap[0] / 2 + j * (size + gap[0]) + size / 2,
              y: gap[1] / 2 + i * (size + gap[1]) + size / 2,
              width: size,
              height: size,
              pivot,
            },
          });
        }
        currentImgIndex++;
      }
    }
  }

  const textStart = [
    -size / 8 + textRegion[0][0] * (size + gap[0]),
    -size / 8 + Math.abs(gap[1] / 8) + textRegion[0][1] * (size + gap[1]),
  ];
  const textEnd = [
    size / 8 - Math.abs(gap[1] / 8) + (textRegion[1][0] + 1) * (size + gap[0]),
    size / 8 - Math.abs(gap[1] / 8) + (textRegion[1][1] + 1) * (size + gap[1]),
  ];
  const cellWidth = (textEnd[0] - textStart[0]) / textColumns;
  const itemsPerColumn = Math.ceil(texts.length / textColumns);
  const cellHeight = (textEnd[1] - textStart[1]) / itemsPerColumn;
  const textSize = fontSize ?? size / 3;
  const positionedTexts = texts.map((txt, index) => {
    const row = index % itemsPerColumn;
    const column = Math.floor(index / itemsPerColumn);
    //console.log('c, r:', column, row);
    const img = positionedImages.find((img) => img.id == txt.id);
    const sideMargin = cellWidth / 16;
    const x =
      (textColumns > 1 ? sideMargin : 0) +
      textStart[0] +
      column * cellWidth +
      cellWidth / 2 -
      column * sideMargin;
    const y = textStart[1] + row * cellHeight + cellHeight / 2;
    return {
      ...txt,
      transform: {
        x,
        y,
        pivot,
      },
      correctTransform: {
        x: img.transform.x,
        y: img.transform.y,
        pivot: { x: 50, y: texts.length == 25 ? -20 : -70 },
      },
      fontSize: txt.fontSize
        ? txt.fontSize * stageWidth
        : stageWidth == window.innerWidth
        ? textSize
        : textSize / (window.innerWidth / stageWidth),
    };
  });

  console.log((window.innerWidth / stageWidth).toFixed(2));
  return [positionedImages, positionedTexts];
}
